





















import { Component, Vue, Watch } from 'vue-property-decorator';
import ProgramsApiAgent,{ GroupedProgram, Program } from '../services/programs-api-agent';

// @ts-ignore
@Component
export default class Programs extends Vue {

  private programs: GroupedProgram = {};

  constructor(private programsApiAgent = ProgramsApiAgent) {
    super();
  }

  mounted() {
    this.programsApiAgent.mounted();
    this.programsApiAgent.getAllGrouped().then(programs => this.programs = programs);
  }

  private formatDate(program: Program) {
    const options = {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    };
    if (program.to.getFullYear() < 1971) {
      if (program.from.getHours() === 0) {
        return program.from.toLocaleDateString();
      }
      return program.from.toLocaleString('hu-HU', options);
    }
    else {
      let result = '';
      result += program.from.getHours() === 0 ? program.from.toLocaleDateString() : program.from.toLocaleString('hu-HU', options);
      result += ' - <br>';
      result += program.to.getHours() === 0 ? program.to.toLocaleDateString() : program.to.toLocaleString('hu-HU', options);
      return result;
    }
  }
}
